/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import NavbarLangOnly from "../../components/Home/navbarLang/NavbarLangOnly";
import { ToastContainer } from "react-toastify";
import CompanyInfoUI from "./CompanyInfoUI";
import useCompanyInfo from "./useCompanyInfo";

export default function CompanyInfo() {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  const navigate = useNavigate();

  const logic = useCompanyInfo(isArabic, navigate);

  const COLORS = {
    darkPurple: "#21003D",
    purple: "#7400BF",
    gold: "#F2B441",
    gradient: "linear-gradient(135deg,#21003D,#7400BF)",
    textLight: "#f3e9ff",
  };

  const paymentOptions = [
    { name: "ZainCash", labelAr: "زين كاش" },
    { name: "MyCard", labelAr: "ماي كارد" },
    { name: "CashOnDelivery", labelAr: "الدفع عند الاستلام" },
  ];

  return (
    <>
      <NavbarLangOnly />
      <ToastContainer />

      <CompanyInfoUI
        COLORS={COLORS}
        isArabic={isArabic}
        paymentOptions={paymentOptions}
        navigate={navigate}
        {...logic}
      />
    </>
  );
}
